import { render } from "./FormSection.vue?vue&type=template&id=6a600044&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"

import "./FormSection.vue?vue&type=style&index=0&id=6a600044&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a600044"]])

export default __exports__